import { useFirebase } from "./firebase";
import { useCollectionDataOnce } from "react-firebase-hooks/firestore";
import { WithId, Survey } from "@kaigi100-next/typing";
import type { Scenario } from "@kaigi100-next/typing/survey";

export function useSurveys(
  conferenceId: string | undefined,
  scenario: Scenario = "before_session"
) {
  const query = conferenceId
    ? useFirebase()
        .firestore()
        .collection(`/live/v1/conferences/${conferenceId}/surveys`)
        .where("scenario", "==", scenario)
        .orderBy("order", "asc")
    : undefined;
  const [value, firebaseLoading, error] = useCollectionDataOnce<WithId<Survey>>(
    query,
    {
      idField: "id",
    }
  );
  const surveys = value;
  const parameterUndefined = !conferenceId;
  const loading = firebaseLoading || parameterUndefined;
  return { surveys, loading, error };
}

export function useSurveyAnswers(
  conferenceId: string | undefined,
  viewerId: string | undefined
) {
  const query =
    conferenceId && viewerId
      ? useFirebase()
          .firestore()
          .collectionGroup("answers")
          .where("indexes.conferenceId", "==", conferenceId)
          .where("viewerId", "==", viewerId)
          .where("indexes.collectionName", "==", "surveyAnswers")
      : undefined;
  const [value, firebaseLoading, error] = useCollectionDataOnce<
    WithId<SurveyAnswer>
  >(query, {
    idField: "id",
  });
  const answers = value;
  const parameterUndefined = !conferenceId || !viewerId;
  const loading = firebaseLoading || parameterUndefined;
  return { answers, loading, parameterUndefined, error };
}
